let faq_arr = [
  {
    id: "Q01",
    title: "目前公開的空污排放量是否具代表性?",
    description: "排放量申報內容為各列管事業（公私場所）主體依法規向地方主管機關申報之資料，需經地方主管機關審查且確認無誤後，方能代表當季或當年度之實際排放量。",
    source: "大氣環境司",
  },
  {
    id: "Q02",
    title: "空污申報狀態中「完成季登錄確認」的代表意義為何?",
    description: "排放量申報狀態中「完成季登錄確認」代表地方主管機關已收件且完成初步完整性審查，尚需進一步進行正確性審查。",
    source: "大氣環境司",
  },
  {
    id: "Q03",
    title: "屬空污列管的對象為何無排放量申報資料?",
    description: "屬空污列管的對象且須符合本部第一批及第二批公私場所應申報年排放量之固定污染源者，才需申報空污排放量，因此未符合公告條件對象者，可能無排放量申報資料。",
    source: "大氣環境司",
  },
  {
    id: "Q04",
    title: "事業(公司場所)水污被列管事由、適用法規、申報種類、申報流程、申報時間及本系統申報排放資料範圍。",
    list: [
      "符合「水污染防治法事業分類及定義」之事業及污水下水道系統，除「水污染防治措施及檢測申報管理辦法」第71條規定之未附設洗車場之加油站等，免予申報外，其餘管制對象則應定檢申報。",
      "定檢申報法源係依水污染防治法第22條規定，事業或污水下水道系統應依主管機關規定之格式、內容、頻率、方式，向直轄市、縣(市)主管機關申報廢(污)水處理設施之操作、放流水水質水量之檢驗測定、用電紀錄及其他有關廢(污)水處理之文件。",
      "事業或污水下水道系統申報之方式，如符合「應以網路傳輸方式辦理水污染防治措施計畫與許可證(文件)之申請、變更或展延，及檢測申報之對象與作業方式」規定者，應以網路申報；其餘採書面申報。",
      "事業或污水下水道系統，如符合「水污染防治措施及檢測申報管理辦法」第93條規定：事業或污水下水道系統應於每年1月31日前，申報前一年7月至12月之資料；每年7月31日前，申報當年1月至6月之資料。如符合第71條第2項之污水下水道系統管理機關(構)，應於每年2月底前，申報前一年7月至12月之資料；每年8月31日前，申報當年1月至6月之資料。如屬免置廢(污)水處理專責人員之社區專用污水下水道系統，應於每年1月31日前，申報前一年1月至12月之資料。",
      "本系統申報排放資料包括申報區間、排放水質及水量、水質採樣日期。",
    ],
    source: "水質保護司",
  },
  {
    id: "Q05",
    title: "請問列管污染源資料(含裁處資訊)查詢系統所提供之事業定位資料，為什麼會出現與地址不符合的情況?",
    description:
      "列管污染源資料(含裁處資訊)查詢系統之事業基本資料(如地址、座標等)，係由本部資源循環署環境保護許可管理資訊網(EMS)所提供，該資料係由地方環保局或事業填寫，若填報者資料填寫錯誤，則會造成事業之座標與地址不相符合之情形。目前EMS資訊網已提供由地址直接轉換座標資料，且增加檢核機制，以避免再有不相符之情形發生。",
    source: "資源循環署",
  },
  {
    id: "Q06",
    title: "為什麼列管污染源資料(含裁處資訊)查詢系統有出現相同事業名稱，但不同管編，且事業地址僅有樓層的差異?",
    list: [
      "現行事業申請管制編號所需檢附之相關證明文件為「工廠登記證明文件」、「公司/商業登記證明文件」或其他目的事業主管機關所核發之證明文件(如醫療機構之開業執照、畜牧場登記證書等)，申請之資料需參照相關證明文件上所登載之資料填寫，如事業名稱、事業地址等。",
      "因固定污染源、水污染、事業廢棄物及毒化物之運作場所列管對象以工廠登記為主，故優先參照「工廠登記證明文件」，而毒化物之運作人所列管之對象為公司(法人)，故優先參照「公司/商業登記證明文件」。",
      "若事業單位之「工廠登記證明文件」與「公司/商業登記證明文件」位於相同地址，但樓層表示方式不同，如地址僅差別在有無列出1樓，則其毒化物之運作人與運作場所則必須申請兩個管制編號，分別列管運作人(法人)及運作場所(工廠)。",
    ],
    source: "資源循環署",
  },
  {
    id: "Q07",
    title: "請問什麼是重複管制編號呢?",
    list: [
      "有關本部空、水、廢、毒之列管同一事業，均係以同一管制編號統一列管，即各事業以「一廠(場)一管編」為管制原則，故不應有不同工廠使用同一管編，或同一工廠有不同管制編號之情事，如事業單位有上述之情形，則稱之為重複管制編號。",
      "如事業因遷移廠址(包含同一縣市鄉鎮遷址)，應重新申請管制編號。如事業負責人變更或公司名稱變更，且涉及組織變更(法人格改變或統一編號改變)，則應重新申請管制編號；如未涉及組織變更者，則無須重新申請管制編號。",
    ],
    source: "資源循環署",
  },
  {
    id: "Q08",
    title: "請問事業單位受到廢棄物列管的原因，相關法源、須申報的種類、流程與時間為何? 列管污染源資料(含裁處資訊)查詢系統可以提供我們查詢什麼資料?",
    list: [
      "依據廢棄物清理法第31條第1項第1款及第2款規定，經中央主管機關指定公告一定規模之事業，應於公告之一定期限辦理事業廢棄物清理計畫書及網路申報事業廢棄物清理流向。",
      "故事業若係屬本部99年8月10日公告「應檢具事業廢棄物清理計畫書之事業」，即應檢具事業廢棄物清理計畫書送審。",
      "若事業係屬本部99年8月10日公告「應以網路傳輸方式申報廢棄物之產出、貯存、清除、 處理、再利用、輸出及輸入情形之事業」，即應依96年2月27日公告之「以網路傳輸方式申報廢棄物之產出、貯存、清除、處理、再利用、輸出及輸入情形之申報格式、項目、內容及頻率」規定，網路申報事業廢棄物產出貯存情形及清理流向(遞送三聯單)。",
      "目前列管污染源資料(含裁處資訊)查詢系統提供查詢屬廢棄物部分，為事業之基本資料、事業廢棄物清理計畫書之廢棄物許可量，及廢棄物聯單申報量。",
    ],
    source: "資源循環署",
  },
  {
    id: "Q09",
    title: "為什麼查詢某一個縣市的事業，點選地圖卻會出現在另外一個縣市呢?",
    list: [
      "現行管制編號之編碼方式，其前三碼為縣市行政區域碼，系統以使用者所填寫之實際廠地址核發一組符合該地區之管制編號。",
      "早期事業之地址資料係由事業自行維護，如事業於更換地址時未重新申請管制編號，而延用舊有之管制編號者，即會造成查詢某一縣市時，出現其它縣市之事業資料。",
      "目前本部管制編號核發系統已改由環保局進行維護及審查，已可排除管制編號行政區碼與地址不相符之情形，本部另持續修正系統現存地址與管制編號前三碼不符之事業。",
    ],
    source: "資源循環署",
  },
  {
    id: "Q10",
    title: "為什麼查詢事業之資料，地址會出現郵政信箱，且無法定位其正確資料呢?",
    description: "此類型之事業皆為軍方之單位，因考量其業務屬性，不宜提供地址及座標資料，故以郵政信箱做為代表之地址，且其座標資料皆非其單位之正確位置，以確保國家機密及安全。",
    source: "資源循環署",
  },
  {
    id: "Q11",
    title: "民眾反映毒化物列管廠家排放資料開放太少問題",
    description: "毒化物列管廠家排放資料開放製造、輸入許可證每月運作量查詢，因製造、輸入係屬源頭運作量，可作為統計國內年運作總量，瞭解國內運作情形。至於使用量或貯存量，是屬於短暫過渡數量，且易與製造、輸入量重複計算，故不列入。",
    source: "化學物質管理署",
  },
  {
    id: "Q12",
    title: "事業單位被「毒性化學物質管理法」列管事由、適用法規、申報種類、申報流程、申報時間及本系統開放資料範圍。",
    list: [
      "列管事由：<br>「毒性化學物質管理法」公告列管毒性化學物質至103年4月30日達302種。製造、輸入達大量運作基準以上之毒性化學物質運作人，應依「毒性化學物質許可登記核可管理辦法」規定，向主管機關申請核發製造、輸入許可證，並依規定定期申報製造、輸入運作量。",
      "適用法規：<br>1.依「毒性化學物質管理法」第八條規定「毒性化學物質之運作及其釋放量，運作人應製作紀錄定期申報，其紀錄應妥善保存備查。前項紀錄之製作、格式、申報內容、頻率、方式、保存及其他應遵行事項之辦法，由中央主管機關定之」。<br/>2.依「毒性化學物質運作及釋放量紀錄管理辦法」定期申報。",
      "申報種類及申報時間：<br>依「毒性化學物質運作及釋放量紀錄管理辦法」第8條之規定，應於每月十日前完成申報前一個月之運作紀錄。毒性化學物質各種運作量無變動者，得免依前項規定申報；但仍應按年申報，於每年一月十日前申報。",
      "申報流程：<br>依「毒性化學物質運作及釋放量紀錄管理辦法」第4條之規定，運作人應依中央主管機關公告格式製作毒性化學物質運作紀錄表、毒性化學物質釋放量紀錄表，並將紀錄表以網路傳輸方式申報。但經主管機關同意以書面申報者，不在此限。",
      "本系統開放資料範圍： 毒化物列管廠家排放資料開放製造、輸入許可證每月運作量查詢，因製造、輸入係屬源頭運作量，可作為統計國內年運作總量，瞭解國內運作情形。",
    ],
    source: "化學物質管理署",
  },
  {
    id: "Q13",
    title: "自願揭露之溫室氣體年排放量盤查資料是什麼?",
    description: "為響應國際間自願碳揭露之趨勢，本部經徵詢業者之意願後，於列管污染源資料(含裁處資訊)查詢系統公開相關排放量資料（資料來源為國家溫室氣體登錄平台），提供各界查詢。本資料係各產業自願盤查登錄之溫室氣體年排放量資料，部分內容未經查驗機構查證，僅能作為初步參考使用。",
    source: "氣候變遷署",
  },
  {
    id: "Q14",
    title: "民眾對各種有害空氣污染物簡易之清潔防護方式為何?",

    description: "民眾對各種有害空氣污染物簡易之清潔防護方式：「因空氣中所存在之各種有害空氣污染物可透過各種環境介質進入人體造成危害，民眾進行戶外活動時，可藉由配戴口罩、個人防護用具、護目鏡等方式做簡易防護，另建議民眾可於空氣品質不良日減少外出，避免可能之暴露危害。」。",
    source: "大氣環境司",
  },
  {
    id: "Q15",
    title: "請問為何有些列管污染源資料原來查的到，現在查不到呢?",
    description: "本部「列管污染源資料(含裁處資訊)查詢系統」資料處理原則為下：當污染源資料列管類別(空污、水污、廢棄物、毒化物)全部解列時，將不再顯示該筆資料。解除列管權責在地方環保局，是否有公告解除列管公文可以查詢，請洽主政之地方環保局。",
    source: "監測資訊司",
  },

  {
    id: "Q16",
    title: "若無法得知列管對象確切資訊，能不能以關鍵字進行精準或模糊查詢?",
    description: "若無列管對象確切管編資料等，您可以使用關鍵字並配合符號『+』限縮查詢範圍，例如『掩埋場+台中』；或用空格『 』來進行模糊查詢，例如『掩埋場 台中』",
    source: "監測資訊司",
  },
  {
    id: "Q17",
    title: "系統的裁處資訊更新的時間為何時?",
    description: "本系統固定每月的15日和30日做資料更新，若資料在第一次（15日）未更新，需等待下一次（30日）的更新。<br>例如事件發生為18日，請等待該月30日過後再上系統確認資料有無更新，如沒更新再聯繫本系統維運團隊協助進一步確認。",
    source: "監測資訊司",
  },
  {
    id: "Q18",
    title: "查詢的資料內容，為什麼有些會被碼掉?",
    description: "本系統資料來源皆為業務單位上傳至NewCDX平臺之資料，本系統僅為公開資料展示之平臺，未針對字號部分進行二次加工。如對資料內容有疑義，請洽詢資料所屬單位。",
    source: "監測資訊司",
  },
  {
    id: "Q19",
    title: "事業有裁處紀錄，但是無列管資料?",
    description: "因為資料來自不同單位，有裁處紀錄不代表該事業會被列管。<br>本系統整合以下不同來源的資料：",
    list: [
      "列管事業污染源裁處資料（EEMS_P_01）｜環境管理署",
      "列管事業資料（EMS_S_01）｜資源循環署",
      "毒性化學物質許可及申報資料（EMS_S_05）｜化學物質管理署",
      "水污染源許可及申報資料（EMS_S_03）｜水質保護司",
      "各工廠空氣污染物排放資料（EMS_S_08）｜大氣環境司",
      "事業廢棄物許可及申報資料（EMS_S_04）｜資源循環司",
      "如對資料內容有疑義，請洽詢上述資料所屬單位。",
    ],
    source: "監測資訊司",
  },
  {
    id: "Q20",
    title: "裁處資料公開有無年限?",
    description: "目前無規定，如需進一步說明請洽裁處資料來源單位「環境管理署」。",
    source: "監測資訊司",
  },
];
